/**
 * @flow
 * @relayHash c05d5cf026214f280ed5ccce44152f06
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type RecommendationContainer_node$ref = any;
type UserPlaylistContainer_node$ref = any;
export type UserPlaylistQuery_QueryVariables = {|
  id: string,
  query: string,
|};
export type UserPlaylistQuery_QueryResponse = {|
  +node: ?{|
    +$fragmentRefs: UserPlaylistContainer_node$ref & RecommendationContainer_node$ref
  |}
|};
export type UserPlaylistQuery_Query = {|
  variables: UserPlaylistQuery_QueryVariables,
  response: UserPlaylistQuery_QueryResponse,
|};
*/


/*
query UserPlaylistQuery_Query(
  $id: ID!
) {
  node(id: $id) {
    __typename
    ... on Playlist {
      ...UserPlaylistContainer_node
      ...RecommendationContainer_node
    }
    id
  }
}

fragment UserPlaylistContainer_node on Playlist {
  id
  can_edit
  title
  description
  thumbnail(width: 240, height: 240) {
    url
    width
    height
    id
  }
  playlist_songs(first: 99999) {
    edges {
      node {
        id
        position
        song {
          __typename
          id
          isrc
          name
          album
          artist
          song_images {
            edges {
              node {
                id
                url
                width
                height
              }
            }
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  song_search(first: 10, query: "") {
    edges {
      node {
        __typename
        id
        name
        album
        artist
        isrc
        duration_ms
        song_images {
          edges {
            node {
              id
              url
              width
              height
            }
          }
        }
        ... on SpotifySong {
          external_id
          external_source
          external_data
        }
      }
    }
  }
}

fragment RecommendationContainer_node on Playlist {
  id
  title
  description
  thumbnail(width: 240, height: 240) {
    url
    width
    height
    id
  }
  playlist_songs(first: 99999) {
    edges {
      node {
        id
        position
        song {
          __typename
          id
          isrc
          name
          album
          artist
          song_images {
            edges {
              node {
                id
                url
                width
                height
              }
            }
          }
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "query",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "width",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "height",
  "args": null,
  "storageKey": null
},
v7 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }
],
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isrc",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "album",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "artist",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "song_images",
  "storageKey": null,
  "args": null,
  "concreteType": "SongImageConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "SongImageEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "SongImage",
          "plural": false,
          "selections": [
            v3,
            v4,
            v5,
            v6
          ]
        }
      ]
    }
  ]
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "UserPlaylistQuery_Query",
  "id": null,
  "text": "query UserPlaylistQuery_Query(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on Playlist {\n      ...UserPlaylistContainer_node\n      ...RecommendationContainer_node\n    }\n    id\n  }\n}\n\nfragment UserPlaylistContainer_node on Playlist {\n  id\n  can_edit\n  title\n  description\n  thumbnail(width: 240, height: 240) {\n    url\n    width\n    height\n    id\n  }\n  playlist_songs(first: 99999) {\n    edges {\n      node {\n        id\n        position\n        song {\n          __typename\n          id\n          isrc\n          name\n          album\n          artist\n          song_images {\n            edges {\n              node {\n                id\n                url\n                width\n                height\n              }\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  song_search(first: 10, query: \"\") {\n    edges {\n      node {\n        __typename\n        id\n        name\n        album\n        artist\n        isrc\n        duration_ms\n        song_images {\n          edges {\n            node {\n              id\n              url\n              width\n              height\n            }\n          }\n        }\n        ... on SpotifySong {\n          external_id\n          external_source\n          external_data\n        }\n      }\n    }\n  }\n}\n\nfragment RecommendationContainer_node on Playlist {\n  id\n  title\n  description\n  thumbnail(width: 240, height: 240) {\n    url\n    width\n    height\n    id\n  }\n  playlist_songs(first: 99999) {\n    edges {\n      node {\n        id\n        position\n        song {\n          __typename\n          id\n          isrc\n          name\n          album\n          artist\n          song_images {\n            edges {\n              node {\n                id\n                url\n                width\n                height\n              }\n            }\n          }\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "UserPlaylistQuery_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "type": "Playlist",
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "UserPlaylistContainer_node",
                "args": null
              },
              {
                "kind": "FragmentSpread",
                "name": "RecommendationContainer_node",
                "args": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "UserPlaylistQuery_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [
          v2,
          v3,
          {
            "kind": "InlineFragment",
            "type": "Playlist",
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "can_edit",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "title",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "description",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "thumbnail",
                "storageKey": "thumbnail(height:240,width:240)",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "height",
                    "value": 240,
                    "type": "Int"
                  },
                  {
                    "kind": "Literal",
                    "name": "width",
                    "value": 240,
                    "type": "Int"
                  }
                ],
                "concreteType": "SongImage",
                "plural": false,
                "selections": [
                  v4,
                  v5,
                  v6,
                  v3
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "playlist_songs",
                "storageKey": "playlist_songs(first:99999)",
                "args": v7,
                "concreteType": "PlaylistSongConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PlaylistSongEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PlaylistSong",
                        "plural": false,
                        "selections": [
                          v3,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "position",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "song",
                            "storageKey": null,
                            "args": null,
                            "concreteType": null,
                            "plural": false,
                            "selections": [
                              v2,
                              v3,
                              v8,
                              v9,
                              v10,
                              v11,
                              v12
                            ]
                          },
                          v2
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "cursor",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "pageInfo",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "endCursor",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "hasNextPage",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedHandle",
                "alias": null,
                "name": "playlist_songs",
                "args": v7,
                "handle": "connection",
                "key": "UserPlaylistContainer_playlist_songs",
                "filters": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "song_search",
                "storageKey": "song_search(first:10,query:\"\")",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10,
                    "type": "Int"
                  },
                  {
                    "kind": "Literal",
                    "name": "query",
                    "value": "",
                    "type": "String!"
                  }
                ],
                "concreteType": "SongConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SongEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": null,
                        "plural": false,
                        "selections": [
                          v2,
                          v3,
                          v9,
                          v10,
                          v11,
                          v8,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "duration_ms",
                            "args": null,
                            "storageKey": null
                          },
                          v12,
                          {
                            "kind": "InlineFragment",
                            "type": "SpotifySong",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "external_id",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "external_source",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "external_data",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8066f059c1060e61e6dceda569e37686';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/App/__generated__/UserPlaylistQuery_Query.graphql.js